<app-tabla
  [totalCount]="totalCount"
  [datos]="dispositivoslorawan"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonCrear"
  [exportar]="botonesHeader"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay dispositivos LoRaWAN' }"
></app-tabla>
